export const handleContactUs = () => {
    window.location.href = 'mailto:hello@diviup.ai';
};
